module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-lg fa-spin fa-spinner"
  }), _vm._v(" Tarkistetaan noutopisteitä...")]) : (!_vm.data.length) ? _c('div') : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Valitse noutopiste")])]), _vm._v(" "), _vm._l((_vm.data), function(item) {
    return _c('pickup-location', {
      key: item.id,
      attrs: {
        "pristine-item": item
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /source/~/vue-loader/lib/template-compiler.js?{"id":"data-v-3f0973bd"}!/source/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickup-locations/list.vue
// module id = 123
// module chunks = 0